"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModal = exports.StyledBackdrop = exports.StyledContent = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const IS_IE11 = '(-ms-high-contrast: none)';
exports.StyledContent = styled_components_1.default.div `
  /* box model */
  max-height: 100%;
  max-width: 100%;
  overflow: auto;

  /* color */
  background-color: ${({ theme }) => theme.colors.white.s100};

  /* other */
  transition-property: transform;
  transition-duration: inherit;
  transition-timing-function: inherit;

  // TODO(fernando.cervera): challenge UX team regarding this max-height and propose a more responsive approach (margins maybe)
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    /* box model */
    max-height: 840px;
  }

  // TODO(fernando.cervera): remove this once the 840px max height is upgraded
  // note(fernando.cervera): safari overflow prevention ugly hack (safari ignores max-height)
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      // note(fernando.cervera): 80vh is a decent ux approximation of the vertical margin of the 840px max height
      //    on desktop since it's unattainable on safari by other means. And on mobile, it patches the
      //    not-a-bug-but-a-feature iOS buttons overflow (https://bugs.webkit.org/show_bug.cgi?id=141832)
      max-height: 80vh;
    }
  }

  ${({ disableStyles, theme }) => !disableStyles &&
    (0, styled_components_1.css) `
      /* box model */
      border-radius: ${theme.radius.s300};
      box-shadow: ${theme.shadow.z5};
    `}

  @media ${IS_IE11} {
    position: static;
  }
`;
exports.StyledBackdrop = styled_components_1.default.div `
  /* position */
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  /* display */
  ${({ hideBackdrop }) => hideBackdrop && 'display: none'};

  /* color */
  background-color: ${({ theme }) => theme.colors.secondary.backdrop};
`;
exports.StyledModal = styled_components_1.default.div `
  /* position */
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;

  /* display */
  transition-property: opacity;
  transition-duration: ${({ duration }) => duration}ms;
  transition-timing-function: ease-in-out;

  /* layout */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* react-transition-group */
  opacity: 0;
  & > ${exports.StyledContent} {
    transform: translateY(100vh);
    @media ${IS_IE11} {
      -ms-transform: none;
    }
  }
  &.enter-active,
  &.enter-done {
    opacity: 1;
    > ${exports.StyledContent} {
      transform: translateY(0);
    }
  }

  @media ${IS_IE11} {
    z-index: 1;
  }
`;
